import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import Button from "../../../../components/Button.jsx";
import Select from "react-select";
import useDownloadState from "../../../../api/utilities/useDownloadState.js";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import googleLogo from "../../../../images/login/g.svg";

export default function MicrosoftIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();

    let adAccountDefaultValues = [];
    let adAccountOptions = [];

    for (let adAccount of projectIntegration?.microsoftIntegrationCustomers ?? []) {
        adAccountOptions.push({
            value: adAccount.remoteId,
            label: '[' + adAccount.remoteNumber + '] ' + adAccount.name
        });

        if (adAccount.enabled) {
            adAccountDefaultValues.push({
                value: adAccount.remoteId,
                label: '[' + adAccount.remoteNumber + '] ' + adAccount.name
            });
        }
    }

    let [selectedAdAccounts, setSelectedAdAccounts] = useState(adAccountDefaultValues);

    const {context, getAuthorityConfiguration, resetCurrentUserProjects} = useContext(GlobalContext);

    let redirectToLogin = () => {
        let oAuthUrl = new URL(import.meta.env.VITE_AUTHORITY_URL);
        oAuthUrl.pathname = '/api/v1/project/integrations/microsoft';

        let query = new URLSearchParams({
            authorization: context.currentIdentity?.token,
            projectId: project.id,
        });

        if (projectIntegration?.id) {
            query.set('integrationId', projectIntegration.id);
        }

        oAuthUrl.search = query.toString();

        window.location.href = oAuthUrl.toString();
    };

    let [saving, setSaving] = useState(false);

    let saveAdAccounts = () => {
        console.log('SAVING!');
        let adAccountIds = [];

        for (let adAccountOption of selectedAdAccounts) {
            adAccountIds.push(adAccountOption.value);
        }

        setSaving(true);
        new ProjectIntegrationsApi(getAuthorityConfiguration())
            .chooseMicrosoftAdAccounts({
                projectId: project.id,
                integrationId: projectIntegration.id,
                requestBody: adAccountIds
            })
            .then(() => {
                resetCurrentUserProjects();
            })
            .finally(() => setSaving(false))
    };

    useEffect(() => {
        if (!projectIntegration) {
            setTimeout(
                () => redirectToLogin(),
                600,
            )
        }
    }, []);

    if (!projectIntegration) {
        return (
            <div>
                <Spinner size={'spinner-large'} className={'mx-auto'}/>
                <p className={'text-center mt-4'}>{t('redirecting')}...</p>
            </div>
        );
    }

    // noinspection JSValidateTypes
    return (
        <LoadingComponent loading={saving || selectedAdAccounts === null}>
            <div className={'text-2xl text-slate-800 dark:text-white mt-6'}>{t('project.ad-accounts')}</div>

            <div className={'w-10/12 mx-auto mt-6'}>
                <Select
                    defaultValue={adAccountDefaultValues}
                    isMulti
                    name="colors"
                    options={adAccountOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={setSelectedAdAccounts}
                />
            </div>

            <div className={'w-10/12 mx-auto mt-2 text-right'}>
                <Button
                    className={'button-primary'}
                    onClick={() => saveAdAccounts()}
                >
                    {t('project.meta.save-ad-accounts')}
                </Button>
            </div>
        </LoadingComponent>
    );
}
